<script setup lang="ts">
import 'primeicons/primeicons.css'
const localeMenuStore = useLocaleMenuStore()
const dragAndDrop = useGlobalDragAndDropStore()
const { isDrag } = storeToRefs(dragAndDrop)
const route = useRoute()
const { locale, locales } = useI18n()
import { useThrottleFn } from '@vueuse/core'
const switchLocalePath = useSwitchLocalePath()
const spinner = useSpinner()

const makeLocaleMenu = () => {
  return locales.value.map((l) => ({
    label: l.name,
    to: switchLocalePath(l.code),
    disabled: l.code === locale.value,
  }))
}

localeMenuStore.setMenu(makeLocaleMenu())

const watchState = computed(() => ({
  locale: locale.value,
  route: route.fullPath,
}))

watch(watchState, () => {
  localeMenuStore.setMenu(makeLocaleMenu())
})

const ddmask = ref<HTMLElement | null>(null)

const dragging = useThrottleFn(() => {
  dragAndDrop.dragging()
})
const undragging = useThrottleFn(() => {
  dragAndDrop.undragging()
})

document.body.addEventListener('dragover', (e) => {
  e.preventDefault()
  dragging()
})

document.body.addEventListener(
  'drop',
  (e) => {
    e.preventDefault()
    undragging()
    dragAndDrop.setDroppedIndex(e.clientX, e.clientY, e)
  },
  { capture: true },
)

// ファイルをウィンドウ外へドラッグして離した(キャンセル)際にオーバーレイを消す
document.body.addEventListener('dragleave', (e) => {
  if (e.relatedTarget === null) {
    undragging()
  }
})

document.addEventListener('dragend', () => {
  undragging()
})

watch(ddmask, (el) => {
  if (el) {
    el.addEventListener('dragover', (e) => {
      e.preventDefault()
      dragging()
    })
    el.addEventListener('drop', (e) => {
      e.preventDefault()
      undragging()
      dragAndDrop.setDroppedIndex(e.clientX, e.clientY, e)
    })
    el.addEventListener('dragleave', (e) => {
      e.preventDefault()
      console.log('leave')
      undragging()
    })
  }
})
</script>

<template>
  <div
    v-if="isDrag"
    class="fixed w-screen h-screen top-0 left-0 opacity-0 z-[2000] pointer-events-none"
    ref="ddmask"
  ></div>

  <NuxtLayout>
    <Toast />
    <DFullScreenSpinner :visible="spinner.visible" />
    <NuxtPage />
  </NuxtLayout>
</template>
